import React, { useEffect, useState } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCardTitle,
  CCol,
  CRow
} from "@coreui/react";
import { InputGroup, Table } from "react-bootstrap";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Label } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import Breadcrumb from "../../../components/Breadcrumb";
import Loading from "../../../components/Loading";
import ProtectedRoute from "../../../components/ProtectedRoute";
import SelectFilter from "../../../components/SelectFilter";
import DataTable from "../../../components/Tables/tables";
import URL from "../../../config/api";
import axios from "../../../config/axios";

import "./styles.css";

const ReportTrails = props => {
  let [loading, setLoading] = useState(true);

  let [groupList, setGroupList] = useState();
  let [groupID, setGroupID] = useState();

  let [regionList, setRegionList] = useState();
  let [regionID, setRegionID] = useState();

  let [schoolList, setSchoolList] = useState();
  let [schoolID, setSchoolID] = useState();

  let [trailList, setTrailList] = useState();
  let [trailID, setTrailID] = useState();
  let [trailName, setTrailName] = useState();
  let [trailLoading, setTrailLoading] = useState(false);

  let [usersTrailData, setUsersTrailData] = useState();
  let [stepsTrailData, setStepsTrailData] = useState();

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(`${URL.api}access/group/list`, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        });

        const groupList = response.data?.data.map(group => ({
          label: group.name,
          value: group.id
        }));
        setGroupList(groupList);

        let group = props.general.active_roles.group_id ?? 0;
        let region = props.general.active_roles.region_id ?? 0;
        let school = props.general.active_roles.school_id ?? 0;

        if (group) {
          setGroupID(group);
          await getRegions(group);

          if (region) {
            setRegionID(region);
            await getSchools(region, group);
          } else {
            getTrails(group, null, null);
          }

          if (school) {
            setSchoolID(school);
            getTrails(group, region, school);
          } else {
            getTrails(group, region, null);
          }
        }
      } catch {
        toastr.error("Falha", "Falha ao buscar os dados!");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const getRegions = async id => {
    if (!id) {
      setRegionID(0);
      setSchoolID(0);
      setTrailID(0);
      setTrailName(undefined);
      return;
    }
    try {
      await axios
        .get(`${URL.api}access/region/listRegionFilter/${id}`, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        })
        .then(resp => {
          const regionList = resp.data?.data.map(region => ({
            label: region.name,
            value: region.id
          }));
          setRegionList(regionList);
        });
    } catch {
      setRegionID(0);
      setSchoolID(0);
    }
  };

  const getSchools = async (id, groupID) => {
    if (!id) {
      setSchoolID(0);
      return;
    }
    try {
      await axios
        .get(`${URL.api}access/school/listSchoolFilter/${groupID}/${id}`, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        })
        .then(resp => {
          const schoolList = resp.data?.data.map(school => ({
            label: school.name,
            value: school.id
          }));
          setSchoolList(schoolList);
        });
    } catch {
      setSchoolID(0);
    }
  };

  const getTrails = (groupID, regionID, schoolID) => {
    try {
      axios
        .get(
          `${
            URL.api
          }activity/trail_allocation/statistics/getTrailsByFilter?group_id=${groupID}&region_id=${
            regionID ?? null
          }&school_id=${schoolID ?? null}`,
          {
            headers: { Authorization: `Bearer ${props.user.token}` }
          }
        )
        .then(resp => {
          const trailList = resp.data?.data.map(trail => ({
            label: trail.name,
            value: trail.id
          }));
          setTrailList(trailList);
        });
    } catch {
      setTrailID(0);
    }
  };

  const getTrailData = async () => {
    setTrailLoading(true);
    await axios
      .get(
        `${
          URL.api
        }activity/trail_allocation/statistics/getTrailBySteps/${trailID}?group_id=${groupID}&region_id=${
          regionID ?? null
        }&school_id=${schoolID ?? null}`,
        { headers: { Authorization: `Bearer ${props.user.token}` } }
      )
      .then(resp => {
        let stepsData = resp.data?.data.map(step => ({
          ...step,
          progress: step.step_completion_percentage
        }));
        setStepsTrailData(stepsData);
      });
    await axios
      .get(
        `${
          URL.api
        }activity/trail_allocation/statistics/usersStepsAverage/${trailID}?group_id=${groupID}&region_id=${
          regionID ?? null
        }&school_id=${schoolID ?? null}`,
        { headers: { Authorization: `Bearer ${props.user.token}` } }
      )
      .then(resp => {
        let usersData = resp?.data.map(user => ({
          ...user,
          progress: user.trail_completion_percentage
        }));
        setUsersTrailData(usersData);
      });
    setTrailLoading(false);
  };

  return (
    <div>
      <Breadcrumb current={props.currentRoute} />
      <CCard>
        <CCardHeader>
          <CCardTitle className="mb-1">Relatório de Trilhas</CCardTitle>
          <div className="small text-muted">
            Monitore o progresso das trilhas desenvolvidas
          </div>
        </CCardHeader>
        <CCardBody>
          {loading ? (
            <Loading />
          ) : (
            <>
              <CCard className="d-flex justify-items-center justify-content-center p-4">
                <CRow>
                  <CCol sm="12" md="10">
                    <CRow>
                      <CCol sm="12" md="3" className="my-2">
                        <SelectFilter
                          title="Grupo"
                          icon="fa-users"
                          placeholder="Selecione um grupo"
                          value={groupID}
                          setFunction={id => {
                            setGroupID(id);
                            getRegions(id);
                            getTrails(id, null, null);
                          }}
                          options={groupList}
                          disabled={!!props.general.active_roles.group_id}
                        />
                      </CCol>
                      <CCol sm="12" md="3" className="my-2">
                        <SelectFilter
                          title="Regiões"
                          icon="fa-globe"
                          placeholder="Todas"
                          value={regionID}
                          setFunction={id => {
                            setRegionID(id);
                            getSchools(id, groupID);
                            getTrails(groupID, id, null);
                          }}
                          options={regionList}
                          disabled={
                            !groupID || !!props.general.active_roles.region_id
                          }
                        />
                      </CCol>
                      <CCol sm="12" md="3" className="my-2">
                        <SelectFilter
                          title="Escolas"
                          icon="fa-institution"
                          placeholder="Todas"
                          value={schoolID}
                          setFunction={id => {
                            setSchoolID(id);
                            getTrails(groupID, regionID, id);
                          }}
                          options={schoolList}
                          disabled={
                            !regionID || !!props.general.active_roles.school_id
                          }
                        />
                      </CCol>
                      <CCol sm="12" md="3" className="my-2">
                        <SelectFilter
                          title="Trilha"
                          icon="fa-code-fork"
                          placeholder="Selecione uma trilha"
                          value={trailID}
                          setFunction={id => {
                            setTrailID(id);
                            setTrailName(
                              trailList.find(trail => trail.value === id).label
                            );
                          }}
                          options={trailList}
                          disabled={!groupID}
                        />
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol
                    sm="12"
                    md="2"
                    className="d-flex align-items-end m-0 p-0"
                  >
                    <CRow className="w-100 p-0 m-0">
                      <CCol sm="12" className="my-2">
                        <InputGroup className="w-100">
                          <CButton
                            color="primary"
                            className="d-flex justify-content-center align-items-center rounded-left rounded-right-0 w-50"
                            disabled={!!trailID}
                            onClick={() => getTrailData()}
                          >
                            <i className="fa fa-filter" />
                            &nbsp; Filtrar
                          </CButton>
                          <CButton
                            color="danger"
                            className="d-flex justify-content-center align-items-center rounded-right rounded-left-0 w-50"
                            onClick={() => {
                              setGroupID(0);
                              setRegionID(0);
                              setSchoolID(0);
                              setTrailID(0);
                              setTrailName(undefined);
                              setUsersTrailData(undefined);
                              setStepsTrailData(undefined);
                            }}
                            disabled={
                              !groupID && !regionID && !schoolID && !trailID
                            }
                          >
                            <i className="fa fa-refresh" />
                            &nbsp; Limpar
                          </CButton>
                        </InputGroup>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCard>
              {trailLoading && <Loading />}
              {usersTrailData ? (
                <>
                  <DataTable
                    noSort
                    list={stepsTrailData}
                    title={trailName}
                    subtitle="Estatísticas dos passos"
                    progressField
                    progressFieldName="% Conclusão"
                    header={[
                      { name: "step", denomination: "Passo" },
                      { name: "users_count", denomination: "N° de estudantes" }
                    ]}
                  />
                  <DataTable
                    noSort
                    list={usersTrailData}
                    title={trailName}
                    subtitle="Estatísticas da trilha"
                    progressField
                    progressFieldName="% Conclusão"
                    header={[
                      { name: "user_name", denomination: "Estudante" },
                      { name: "current_step", denomination: "Passo atual" }
                    ]}
                  />
                </>
              ) : (
                <>
                  {!trailLoading ? (
                    <p className="w-100 text-center">
                      Selecione ao menos o grupo e uma trilha para obter o
                      resultado.
                    </p>
                  ) : (
                    <></>
                  )}
                </>
              )}
            </>
          )}
        </CCardBody>
      </CCard>
      <ProtectedRoute routeId={props.currentRoute} />
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch => bindActionCreators({ logout }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReportTrails);
